import {inject, Injectable} from '@angular/core';
import {TranslationDataService} from "../../translations/services/translation-data.service";
import {QueryDataService} from "../../query/components/services/query-data.service";
import {forkJoin, lastValueFrom, of} from "rxjs";
import {catchError} from "rxjs/operators";
import Keycloak from "keycloak-js";

@Injectable({
    providedIn: 'root'
})
export class BootstrapService {
    private readonly translationService = inject(TranslationDataService);
    private readonly queryService = inject(QueryDataService);
    private readonly keycloak = inject(Keycloak);

    public async initApplicationData() {
        if (!this.keycloak.authenticated) {
            return;
        }

        await lastValueFrom(forkJoin([
            this.translationService.getTranslationsOverview(),
            this.queryService.getQueries()
        ]).pipe(
            catchError(err => {
                console.error('Error initializing application data', err);
                return of(null);
            })
        ));
    }
}
